import { render, staticRenderFns } from "./DownloadedLearningObjectRow.vue?vue&type=template&id=48965cd6&scoped=true"
import script from "./DownloadedLearningObjectRow.vue?vue&type=script&lang=js"
export * from "./DownloadedLearningObjectRow.vue?vue&type=script&lang=js"
import style0 from "./DownloadedLearningObjectRow.vue?vue&type=style&index=0&id=48965cd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48965cd6",
  null
  
)

export default component.exports